import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';
import Select from 'react-select';

import UserIconList from 'components/user_icon_list';
import { mapId, mapName } from 'helpers/react_select_helpers';

export default class IntegrationModal extends React.Component {

  static propTypes = {
    calendar: PropTypes.bool,
    children: PropTypes.object.isRequired,
    currentDatabase: PropTypes.object,
    databases: PropTypes.array,
    disconnectModal: PropTypes.bool,
    shown: PropTypes.bool,
    title: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  static defaultProps = {
    calendar: false,
    disconnectModal: false,
    databases: [{}]
  }
  state = {
    database: this.props.currentDatabase || this.props.databases[0],
    disableBtn: false
  }

  handleDatabaseSelect = (database) => {
    this.setState({ database });
  }

  handleSave = () => {
    const { onSave } = this.props;

    this.setState({ disableBtn: true });
    onSave().then(() => {
      this.setState({ disableBtn: false });
    });
  }

  renderSignInButton = () => {
    const {
      calendar,
      onSave
    } = this.props;
    const { database } = this.state;

    if (calendar) {
      return (
        <img
          className="clickable google-img"
          src={'/images/google_integration/btn_google_signin_dark_normal_web.png'}
          onClick={() => onSave(database.id)}
        />
      );
    } else {
      return (
        <button className='btn btn-sm btn-save' onClick={() => onSave(database.id)}>Save Changes</button>
      );
    }
  }

  render() {
    const {
      children,
      disconnectModal,
      shown,
      databases,
      title,
      onCancel
    } = this.props;
    const { database, disableBtn } = this.state;
    const databaseText = databases && database.members && database.members.length == 1 ? "User" : "Users";

    return (
      <Modal className="integration-modal" show={shown} onHide={onCancel}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mb-3">
          {children}
          {disconnectModal ?
            <div className="mt-4 mb-4 text-center">
              <button
                className='btn btn-md btn-danger'
                disabled={disableBtn}
                onClick={this.handleSave}
              >
                {disableBtn ? "Disconnecting Account..." : "Disconnect Account"}
              </button>
            </div> :
            <div className="select-database mt-3">
              <h5>Select Database</h5>
              <div>
                <Select
                  className="col-xs-4 pl-0"
                  classNamePrefix="database-selector"
                  getOptionLabel={mapName}
                  getOptionValue={mapId}
                  options={databases}
                  value={database}
                  onChange={this.handleDatabaseSelect}
                />
                <div className="users-list">
                  <span>{database.members.length} {databaseText}</span>
                  <UserIconList size="24px" users={database.members}/>
                </div>
              </div>
            </div>
          }
        </Modal.Body>
        {!disconnectModal &&
          <Modal.Footer className="text-left">
            <button className='btn btn-sm btn-cancel' onClick={onCancel}>Cancel</button>
            {this.renderSignInButton()}
          </Modal.Footer>
        }
      </Modal>
    );
  }
}
